export default __webpack_public_path__ + "static/media/desktop_tc1_En.4e13ab65.webp";